/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { string, bool, shape, func, object } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { hideErrorMessage as hideErrorMessageAction } from 'actions/error';

import SystemMessage from 'components/SystemMessage/SystemMessage';

/**
 * This is the ErrorMessage component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class ErrorMessage extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    errorMessage: shape({
      show: bool,
      message: string.isRequired,
    }).isRequired,
    location: object.isRequired,
    hideErrorMessage: func.isRequired,
  };

  static timerId = null;

  componentDidUpdate(prevProps) {
    const {
      errorMessage: { show },
    } = prevProps;
    const {
      errorMessage: { show: nextShow },
    } = this.props;

    if (!show && nextShow) {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => this.hideMessage(), 6000);

      process.nextTick(() => window.scrollTo(0, 0));
    }
  }

  shouldComponentUpdate(nextProps) {
    const {
      errorMessage: { show },
    } = this.props;
    const {
      errorMessage: { show: nextShow },
    } = nextProps;

    return show !== nextShow;
  }

  onClick = () => {
    clearTimeout(this.timerId);
    this.hideMessage();
  };

  hideMessage = () => {
    const {
      errorMessage: { show },
      hideErrorMessage,
    } = this.props;

    if (show) {
      hideErrorMessage();
    }
  };

  /**
   * Render ErrorMessage.
   *
   * @return {Object}
   */
  render() {
    const {
      location: { pathname },
      errorMessage: { show, message },
    } = this.props;
    const offsetTop = pathname.includes('/account');

    if (!show) {
      return null;
    }

    return (
      <SystemMessage
        error
        message={message}
        offsetTop={offsetTop}
        onClick={this.onClick}
      />
    );
  }
}

export default withRouter(
  connect(
    ({ errorMessage }) => ({ errorMessage }),
    {
      hideErrorMessage: hideErrorMessageAction,
    }
  )(ErrorMessage)
);
